import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { RecComponent } from './rec.component';
import { RecRoutingModule } from './rec-routing.module';
import { ShareService } from './services/share.service';
import { WebAudioFactory } from './factories/web-audio.factory';
import { Player } from './entities/player';
import { TimelineCanvasProcessLevelsStore } from './timeline/timeline-canvas/timeline-canvas-process-levels.store';
import { RecorderStore } from './stores/recorder.store';
import { TimelineStore } from './timeline/timeline.store';
import { Recorder } from './entities/recorder';
import { TimelineTimerComponent } from './components/timer/timer.component';
import { MillisecondsPipe } from './pipes/milliseconds.pipe';
import { TimelineComponent } from './timeline/timeline.component';
import { TimelineScaleComponent } from './timeline/timeline-scale/timeline-scale.component';
import { TimelineLayerComponent } from './timeline/timeline-layer/timeline-layer.component';
import { TimelineLayersComponent } from './timeline/timeline-layers/timeline-layers.component';
import { TimelineScaleTickComponent } from './timeline/timeline-scale/timeline-scale-tick/timeline-scale-tick.component';
import { TimelineButtonsComponent } from './timeline/timeline-buttons/timeline-buttons.component';
import { TimelineSliderComponent } from './timeline/timeline-slider/timeline-slider.component';
import { TimelineCanvasComponent } from './timeline/timeline-canvas/timeline-canvas.component';
import { TimelineLayerAddComponent } from './timeline/timeline-layer-add/timeline-layer-add.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { TimelineLayerVolumeComponent } from './timeline/timeline-layer/timeline-layer-volume/timeline-layer-volume.component';
import { TimelineLayerSelectComponent } from './timeline/timeline-layer/timeline-layer-select/timeline-layer-select.component';
import { TimelineLayerRemoveComponent } from './timeline/timeline-layer/timeline-layer-remove/timeline-layer-remove.component';
import { ShareDownloadComponent } from './components/share/share-download/share-download.component';
import { ShareLinkComponent } from './components/share/share-link/share-link.component';
import { ShareComponent } from './components/share/share.component';
import { RecordButtonsComponent } from './components/record-buttons/record-buttons.component';
import { ToolbarShareComponent } from './components/toolbar/toolbar-share/toolbar-share.component';
import { ShareLinkModalComponent } from './components/share/share-link/share-link-modal/share-link-modal.component';
import { TimelineBlockComponent } from './timeline/timeline-block/timeline-block.component';

@NgModule({
  imports: [
    SharedModule,
    RecRoutingModule,
  ],
  declarations: [
    RecComponent,
    TimelineTimerComponent,
    MillisecondsPipe,
    TimelineComponent,
    TimelineScaleComponent,
    TimelineLayerComponent,
    TimelineLayersComponent,
    TimelineScaleTickComponent,
    TimelineButtonsComponent,
    TimelineSliderComponent,
    TimelineCanvasComponent,
    TimelineLayerAddComponent,
    ToolbarComponent,
    TimelineLayerVolumeComponent,
    TimelineLayerSelectComponent,
    TimelineLayerRemoveComponent,
    ShareDownloadComponent,
    ShareLinkComponent,
    ShareComponent,
    RecordButtonsComponent,
    ToolbarShareComponent,
    ShareLinkModalComponent,
    TimelineBlockComponent,
  ],
  providers: [
    Recorder,
    TimelineStore,
    RecorderStore,
    TimelineCanvasProcessLevelsStore,
    Player,
    WebAudioFactory,
    ShareService,
  ],
})
export class RecModule {
}



// WEBPACK FOOTER //
// ./src/app/rec/rec.module.ts